const interfaseMediator = { notify: () => {} };

export const useMediator = (initVal = interfaseMediator) => {
  let mediator = initVal;

  const getMediator = () => mediator;
  const setMediator = (obj) => {
    mediator = obj;
  };
  const destroyMediator = () => {
    mediator = null;
  };

  return [getMediator, setMediator, destroyMediator];
};
